<template>
  <highcharts
    :ref="`ascStockChart${_uid}`"
    class="highcharts"
    :constructor-type="'stockChart'"
    :options="chartOptions"
  ></highcharts>
</template>

<script>
export default {
  name: 'AscStockChart',

  props: {
    options: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      chartRef: null,
      chartOptions: this.options,
    }
  },

  watch: {
    options: {
      handler(newObj) {
        this.chartOptions = newObj
      },
      deep: true,
    },
  },

  mounted() {
    this.chartRef = this.$refs[`ascStockChart${this._uid}`]
  },
}
</script>

<style lang="scss" scoped>
.highcharts {
  width: 100%;
  margin: 0 auto;
}
</style>
